var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { useState } from "react";
import { FormGroup } from 'reactstrap';
import Icon from "./Icon";
import { Input as InputReactstrap } from "reactstrap";

var CustomPassword = function (_InputReactstrap) {
  _inherits(CustomPassword, _InputReactstrap);

  function CustomPassword(props) {
    _classCallCheck(this, CustomPassword);

    var _this = _possibleConstructorReturn(this, (CustomPassword.__proto__ || Object.getPrototypeOf(CustomPassword)).call(this, props));

    _this.state = {
      hidden: true,
      password: ''
    };
    _this.handlePasswordChange = _this.handlePasswordChange.bind(_this);
    _this.toggleShow = _this.toggleShow.bind(_this);
    return _this;
  }

  _createClass(CustomPassword, [{
    key: "handlePasswordChange",
    value: function handlePasswordChange(e) {
      this.setState({ password: e.target.value });
    }
  }, {
    key: "toggleShow",
    value: function toggleShow() {
      this.setState({ hidden: !this.state.hidden });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.password) {
        this.setState({ password: this.props.password });
      }
    }
  }, {
    key: "render",
    value: function render() {

      return React.createElement(
        FormGroup,
        null,
        React.createElement(
          "div",
          {
            "class": "align_pass" },
          React.createElement(InputReactstrap, {
            type: this.state.hidden ? 'password' : 'text',
            value: this.props.value,
            name: this.props.name,
            label: this.props.label,
            onChange: this.props.onChange,
            invalid: this.props.invalid,
            valid: this.props.valid,
            innerRef: this.props.innerRef,
            htmlFor: this.props.htmlFor,
            inline: this.props.inline,
            id: this.props.id,
            key: this.props.key,
            size: this.props.size,
            bsSize: this.props.bsSize,
            required: this.props.required,
            autoComplete: this.props.autoComplete,

            className: "custom-password"
          }),
          React.createElement(
            "span",
            { className: this.props.invalid ? "password_button is-invalid" : this.props.valid ? "password_button was-valid" : "password_button", size: "xs", onClick: this.toggleShow },
            this.state.hidden ? "Mostrar" : "Ocultar",
            React.createElement(Icon, { size: 22, position: "relative", left: "0px", top: "5px", icon: this.state.hidden ? "poli-icon pi-eye-fill" : "poli-icon pi-eye-hide-fill" })
          )
        )
      );
    }
  }]);

  return CustomPassword;
}(InputReactstrap);

export default CustomPassword;